import PropTypes from 'prop-types';
import { Icon } from '@veeva/corgix/icon';
import { ThemeProvider } from 'emotion-theming';
import { forwardRef } from 'react';
import { iconButtonDisabledCSS, iconButtonOverridesCSS } from './styles/IconButton.styles';

const IconButtonWithRef = forwardRef(function IconButton(
    { className, icon, iconSize, onClick, onFocus, title, disabled },
    ref,
) {
    const handleButtonClick = () => {
        onClick();
        if (ref?.current) {
            ref.current.blur();
        }
    };
    return (
        <ThemeProvider theme={{ iconSizeSM: '14px' }}>
            <button
                className={className}
                css={disabled ? iconButtonDisabledCSS : iconButtonOverridesCSS}
                onFocus={onFocus}
                onClick={handleButtonClick}
                ref={ref}
                type="button"
                disabled={disabled}
            >
                <Icon size={iconSize} type={icon} title={title} />
            </button>
        </ThemeProvider>
    );
});

IconButtonWithRef.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string,
        PropTypes.element,
        PropTypes.object,
    ]).isRequired,
    iconSize: Icon.propTypes.size,
    onClick: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    title: PropTypes.string,
};

export default IconButtonWithRef;
